import { render } from "./OfertaDetail.vue?vue&type=template&id=69bf9b18&scoped=true"
import script from "./OfertaDetail.vue?vue&type=script&lang=js"
export * from "./OfertaDetail.vue?vue&type=script&lang=js"

import "./OfertaDetail.vue?vue&type=style&index=0&id=69bf9b18&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javier.padilla\\git-repositories\\proyectos.ges.com\\com.ges.proyectos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69bf9b18"]])

export default __exports__